<div class="manage-relationship-dialog">
    <tam-dialog [opened]="opened" [dialogWidth]="696" class="container">
        <ng-template #title>
            <div class="dialog-title">Manage Relationships in the Web</div>
        </ng-template>
        <ng-template #body>
            <div class="body-container">
                <div class="title">
                    Allow everyone to manage Relationships through Rel-Tree
                    <kendo-switch onLabel="Yes" offLabel="No" [(ngModel)]="isPublicAuthorization"
                        style="margin-left: 120px;">
                    </kendo-switch>
                </div>
                <div class="recipients-container">
                    <div class="note-description">
                        *Users with administrative credentials are not restricted by this setting.
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #footer>
            <div class="footer-container">
                <button tam-button tamType="tertiary" tamSize="normal" (click)="cancel()">Cancel</button>
                <button tam-button tamType="primary" tamSize="normal" (click)="apply()" [tamLoading]="isProgressing"
                    [disabled]="isProgressing">Apply</button>
            </div>
        </ng-template>
    </tam-dialog>
</div>